export default {
  set_error(state, error) {
    state.errors = error;
  },
  set_locations(state, {locations}) {
    state.locations = locations.data;
    state.totalCount = locations.total;
    state.count = locations.total;
  },
  set_loading(state) {
    state.loading = true;
  },
  unset_loading(state) {
    state.loading = false;
  }
};
